exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".other-viewer{display:flex;flex-direction:column;justify-content:center}.other-viewer>div{display:flex;justify-content:center;align-items:center;width:600px;height:400px}.other-viewer>div .fa-icon{font-size:220px}", ""]);

